import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-0 flex justify-center items-center h-20"
}
const _hoisted_2 = { class: "absolute z-10 left-0 top-0 flex min-w-16 w-max bg-[#d5be6e] rounded-br-md" }
const _hoisted_3 = { class: "text-xs text-black pt-1 pb-0.5 px-2" }
const _hoisted_4 = {
  key: 1,
  class: "relative z-0"
}
const _hoisted_5 = { class: "absolute z-10 left-0 top-0 flex min-w-16 w-max bg-[#d5be6e] rounded-br-md" }
const _hoisted_6 = { class: "text-xs text-black pt-1 pb-0.5 px-2" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "relative z-0" }
const _hoisted_9 = { class: "absolute z-10 left-0 top-0 flex min-w-16 w-max bg-[#d5be6e] rounded-br-md" }
const _hoisted_10 = { class: "text-xs text-black pt-1 pb-0.5 px-2" }
const _hoisted_11 = { class: "static z-0 pt-8 pb-5 pl-5 pr-20 text-start" }
const _hoisted_12 = { class: "text-xl text-amber-50" }
const _hoisted_13 = { class: "absolute z-10 right-3 bottom-1/2 translate-y-1/2" }

export function render(_ctx, _cache) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Card, { pt: {root: 'overflow-hidden! bg-transparent! bg-[linear-gradient(180deg,#2d2d2dba,#281401ba)]! border! border-[#d5be6e]!', body: '!p-0' } }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createCommentVNode(" แถบ Label "),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.label), 1 /* TEXT */)
            ]),
            _createVNode(_component_ProgressSpinner, {
              style: {"width":"50px","height":"50px"},
              strokeWidth: "4",
              fill: "transparent",
              animationDuration: ".5s"
            })
          ]))
        : (!_ctx.isActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createCommentVNode(" แถบ Label "),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.detail.label), 1 /* TEXT */)
              ]),
              _createCommentVNode(" จำนวนเงิน "),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "static z-0 pt-8 pb-5" }, [
                _createElementVNode("span", { class: "text-black text-xl" }, "ปิดใช้งานอยู่ใน ขณะนี้")
              ], -1 /* HOISTED */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createCommentVNode(" แถบ Label "),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.detail.label), 1 /* TEXT */)
                ]),
                _createCommentVNode(" จำนวนเงิน "),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatCurrency(_ctx.detail.amount)), 1 /* TEXT */)
                ]),
                _createCommentVNode(" ปุ่มถอน "),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createVNode(_component_Button, {
                    onClick: _ctx.handleWithdraw,
                    label: _ctx.detail.btnLabel,
                    loading: _ctx.detail.btnLoading,
                    disabled: _ctx.detail.btnDisabled,
                    size: "small",
                    class: "min-w-16 bg-[url(https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/btnn-3.webp)]! bg-size-[100%_100%]! bg-transparent! border-0! border-transparent"
                  }, null, 8 /* PROPS */, ["onClick", "label", "loading", "disabled"]), [
                    [
                      _directive_tooltip,
                      {
								value: _ctx.detail.btnTooltip,
								pt: {
									text: 'text-[12px]!',
								},
							},
                      void 0,
                      { left: true }
                    ]
                  ])
                ])
              ]),
              _renderSlot(_ctx.$slots, "table")
            ]))
    ]),
    _: 3 /* FORWARDED */
  }))
}